const config = {
  apiRoot: parse(process.env.VUE_APP_API_ROOT, 'API_ROOT_NOT_SET'),
  useCustomCurrencyFormat: parse(process.env.VUE_APP_USE_CUSTOM_CURRENCY_FORMAT, true),
  dateFormatOptions: {
    weekday: parse(process.env.VUE_APP_DATE_FORMAT_WEEKDAY, 'short'),
    month: parse(process.env.VUE_APP_DATE_FORMAT_MONTH, '2-digit'),
    day: parse(process.env.VUE_APP_DATE_FORMAT_DAY, '2-digit'),
    year: parse(process.env.VUE_APP_DATE_FORMAT_YEAR, 'numeric'),
  },
  features: {
    test: 'test'
  }
}

function feature (name) {
  return config.features[name]
}

function parse (value, fallback) {
  if (typeof value === 'undefined') {
    return fallback
  }
  switch (typeof fallback) {
    case 'boolean' :
      return !!JSON.parse(value)
    case 'number' :
      return JSON.parse(value)
    default :
      return value
  }
}

export {
  config
}

export default {
  install (Vue) {
    Vue.appConfig = config
    Vue.feature = feature
    Vue.prototype.$appConfig = config
    Vue.prototype.$feature = feature
  }
}
